import { SlicePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPercentVal'
})
export class FormatPercentValPipe implements PipeTransform {
    //   transform(value: unknown, ...args: unknown[]): unknown {
    //     return null;
    //   }
    transform(value: string, arg?: string): any {
        let val: string = String(value);
        let slicedValue: string;
        
        if ((val === 'NaN') || val == 'null') {            
            return '0.0 %';       
        } else {
            return val;
        }
    }
}
